<template>
  <div class="contain">
    <van-popup
      v-model="isShow"
      position="bottom"
      :style="{ height: '70%' }"
      @click-overlay="onClose"
      :close-on-click-overlay="false"
    >
      <div class="search-box">
        <van-search placeholder="请输关键字搜索" v-model="keywords" @input="onSearch" />
      </div>
      <div style="height:44px"></div>
      <div class="user-box">
        <!--:label="(item.sex)+' '+item.grade+' '+item.num_str"-->
          <van-cell-group>
            <van-cell
              v-for="(item, index) in options"
              clickable
              :key="index"
              @click="toggle(item)"
              :v-if="index < limit"
            >
              <template slot="title">
                <div class="custom-title">{{item.name}}</div>
              </template>
              <van-checkbox
                v-model="item.checked"
                slot="right-icon"
                checked-color="#FD2840"
              />
            </van-cell>
          </van-cell-group>
      </div>
      <div class="createbtn">
        <van-button type="danger" size="large" @click="onConfirm">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  CheckboxGroup
} from "vant";

Vue.use(Popup)
  .use(Toast)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Search)
  .use(Checkbox)
  .use(CheckboxGroup);

export default {
  name: "DakejianDanweiPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      isShow: false,
      result: [],
      list:[],
      keywords: "",
    };
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.id) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.id
      })
    }
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },

  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },

    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            Toast('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
            "/api/zdakejian/danweiOptions",
            { keywords: this.keywords },
        res => {
          that.list = [...res.data];
        }
      );
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    }
  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// DakejianDanweiPicker.vue?46f7df56